import { END_POINTS } from "@/constants/url";
import emptySplitApi from "@/lib/rtk";
import { CommonResponseType } from "@/types/General";

export const homeService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    homePage: builder.query<CommonResponseType & { data: { data: any[] } }, {}>(
      {
        query: ({ }) => ({
          url: `${END_POINTS.dashboard}?limit=25`,
          method: "POST",
        }),
        keepUnusedDataFor: 300,
        providesTags: ["DASHBOARD"],
        async onQueryStarted(arg, { queryFulfilled }) {
          try {
            const { data } = await queryFulfilled;
            console.log("homePage response:", data);
          } catch (error) {
          }
        },
      }
    ),
    getProducts: builder.query<
      CommonResponseType & { data: { data: any[]; total?: number } },
      {
        type?: number;
        page?: number;
        limit?: number;
        latitude?: number;
        longitude?: number;
        brand_id?: number | string;
      }
    >({
      query: ({
        type = 2,
        page = 1,
        limit = 10,
        latitude = 28.6573,
        longitude = 77.1642,
        brand_id,
      }) => {
        const queryParams = new URLSearchParams();
        queryParams.append("type", type.toString());
        queryParams.append("page", page.toString());
        queryParams.append("limit", limit.toString());
        queryParams.append("latitude", latitude.toString());
        queryParams.append("longitude", longitude.toString());
        if (brand_id) {
          queryParams.append("brand_id", brand_id.toString());
        }
        return {
          url: `${END_POINTS.getProducts}?${queryParams.toString()}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 300,
    }),
    getProductDetails: builder.mutation<
      CommonResponseType & { data: any; recommended_products?: any[] },
      { store_id: number | string; product_id: number | string }
    >({
      query: ({ store_id, product_id }) => {
        const formData = new FormData();
        formData.append("store_id", store_id.toString());
        formData.append("product_id", product_id.toString());
        return {
          url: `${END_POINTS.getProductDetails}`,
          method: "POST",
          body: formData,
        };
      },
    }),
    viewAllCategory: builder.query<
      CommonResponseType & { data: any[] },
      void
    >({
      query: () => ({
        url: `${END_POINTS.viewAllCategory}`,
        method: "POST",
        body: {},
      }),
      keepUnusedDataFor: 300,
      providesTags: ["CATEGORY"],
    }),
    getCategoryList: builder.query<
      CommonResponseType & {
        data: {
          id: number;
          name: string;
          image_url: string;
          parent_id: number;
          icon_url: string;
        }[];
      },
      void
    >({
      query: () => ({
        url: `${END_POINTS.CATEGORY_LIST}`,
        method: "GET",
      }),
    }),
    viewAllProduct: builder.query<
      CommonResponseType & { data: { data: any[]; total?: number } },
      {
        page?: number;
        limit?: number;
        type?: string;
        sortId?: number;
        category_id?: number | string;
        brand_id?: number | string;
        productIds?: number[] | string[];
        brandIds?: number[] | string[];
        categoryIds?: number[] | string[];
      }
    >({
      query: ({
        page = 1,
        limit = 10,
        type,
        sortId,
        category_id,
        brand_id,
        productIds,
        brandIds,
        categoryIds,
      }) => {
        const queryParams = new URLSearchParams();
        queryParams.append("page", page.toString());
        queryParams.append("limit", limit.toString());

        const body: any = {};
        if (type) {
          body.type = type;
        }
        if (sortId) {
          body.sortId = sortId;
        }
        if (category_id) {
          body.category_id = category_id;
        }
        if (brand_id) {
          body.brand_id = brand_id;
        }
        if (productIds && productIds.length > 0) {
          body.productIds = productIds;
        }
        if (brandIds && brandIds.length > 0) {
          body.brandIds = brandIds;
        }
        if (categoryIds && categoryIds.length > 0) {
          body.categoryIds = categoryIds;
        }

        return {
          url: `${END_POINTS.viewAllProduct}?${queryParams.toString()}`,
          method: "POST",
          body,
        };
      },
      keepUnusedDataFor: 300,
    }),
    getCategoryDashboard: builder.query<
      CommonResponseType & { data: { data: any[] } },
      { categoryId: number; page?: number; limit?: number }
    >({
      query: ({ categoryId, page = 1, limit = 10 }) => ({
        url: `${END_POINTS.CATEGORY_DASHBOARD}?page=${page}&limit=${limit}`,
        method: "POST",
        body: { categoryId },
      }),
      keepUnusedDataFor: 300,
      providesTags: ["DASHBOARD"],
    }),
  }),
});

export const {
  useHomePageQuery,
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useGetProductDetailsMutation,
  useViewAllCategoryQuery,
  useLazyViewAllCategoryQuery,
  useViewAllProductQuery,
  useLazyViewAllProductQuery,
  useGetCategoryListQuery,
  useGetCategoryDashboardQuery,
} = homeService;
